import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Stack, { StackProps } from "@mui/material/Stack";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { colors } from "../../../../theme/colors";
import { useBreakpoints } from "../../../../hooks/useBreakpoins";

export function CustomBreadcrumbs({
  crumbs,
  config,
}: {
  crumbs: { path: string; crumbName: string }[];
  config?: StackProps;
}) {
  const { isMobile } = useBreakpoints();
  const breadcrumbs = crumbs.map((item, index) => (
    <Link
      underline="hover"
      key={index}
      color="inherit"
      href={item.path}
      style={{ fontSize: isMobile ? 12 : 16 }}
    >
      {item.crumbName}
    </Link>
  ));

  return breadcrumbs.length > 0 ? (
    <Stack spacing={1} sx={{ mt: 2, ml: 2 }} {...config}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        sx={{ color: colors.purple[500], fontWeight: 500 }}
      >
        {breadcrumbs}
      </Breadcrumbs>
    </Stack>
  ) : (
    <></>
  );
}
